import React from 'react';
import { connect } from 'react-redux';
import { push as changeURL } from 'react-router-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames';
import css from './index.css';
import stateData from '../../../misc/country-info';
import sharedCSS from '../../shared.css';

const StateList = props => {
  const jumpTo = url => {
    props.gotoPage(url);
  };
  return (
    <div className={css.container}>
      <p className={cs(sharedCSS.h1, css.title)}>Find truck loads by State</p>
      <div className={css.listContainer}>
        <p className={css.countryTitle}>USA</p>
        <div className={css.stateContainer}>
          {stateData.US.map(item => (
            <span
              key={item.label}
              className={css.stateItem}
              // href={`/searchloads/${item.label}/all-loads?from_country_name=US&from_state_name=${item.value}`}
              onClick={() =>
                jumpTo(
                  `/searchloads/${item.label}/all-loads?from_country_name=US&from_state_name=${item.value}`
                )
              }>
              {item.label} ({item.value})
            </span>
          ))}
        </div>
      </div>
      <div className={css.listContainer}>
        <p className={css.countryTitle}>Canada</p>
        <div className={css.stateContainer}>
          {stateData.CA.map(item => (
            <span
              key={item.label}
              className={css.stateItem}
              // href={`/searchloads/${item.label}/all-loads?from_country_name=CA&from_state_name=${item.value}`}
              onClick={() =>
                jumpTo(
                  `/searchloads/${item.label}/all-loads?from_country_name=CA&from_state_name=${item.value}`
                )
              }>
              {item.label} ({item.value})
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default connect(
  user => ({ user }),
  mapDispatch({
    gotoPage: (_, url) => changeURL(url),
  })
)(StateList);



// WEBPACK FOOTER //
// ./src/components/common/StateList/index.js